import React, { Component } from 'react'
import Form from '../common/form/Form'
import { getWord } from '../../tools/tools'


export default class AuthStepCode extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    // static contextTypes = {
    //     screenSize: PropTypes.string,
    //     currentLanguage: PropTypes.object,
    //     translate: PropTypes.func
    // }
    componentDidMount() {
        if (this.props.step === 2) {
            this.setState({ time: 30 }, () => {
                this.timer = setInterval(this.setTime, 1000);
            });
        }
    }

    render() {

        let {
            onCodeValidate,
            renderFields,
            triesMore,
            step,
            onRepeatCodeRequest,
            toCodeRequest,
            time,
            fieldsCodevalidate,
            context,
            isValid,
            sendRequest
        } = this.props

        return (
            <div> <Form className={"auth__form-slide" + (step == 2 ? " active" : "")}
                validate={true}
                onSubmit={onCodeValidate}
            >
                <h3 className="auth__titile">Вход</h3>

                <div className='auth_inputs'>
                    {renderFields(fieldsCodevalidate, 'fieldsCodevalidate')}
                </div>
                {triesMore ? <div className="form__message">
                    <div className="form__message-fix">
                        <p dangerouslySetInnerHTML={{
                            __html: context.translate("У вас осталось {n} {unit} ввести код, после чего аккаунт будет заблокирован.", {
                                n: '<span className="t-red t-bold">' + triesMore + '</span>',
                                unit: getWord(triesMore, 'попытка', 'попытки', 'попыток')
                            })
                        }} />
                    </div>

                </div> : null}
                {time ? <div> <p className='auth__form_counter'>{context.translate("Вы сможете запросить код повторно через {n} сек.", {
                    n: "00:" + time
                })}

                </p>
                </div>
                    : null}
                <a href="#" className={time == 0 ? "" : "disabled"}
                    onClick={onRepeatCodeRequest}>{context.translate("Запросить повторно")}</a>
                <div className="form__buttons_auth">
                    <button className="btn btn_clear_blue_auth" type="button"
                        onClick={toCodeRequest}>{context.translate("Назад")}</button>
                    <button
                        className={"btn btn_orange" + (isValid('fieldsCodevalidate') && !sendRequest && fieldsCodevalidate.code.value ? "" : " btn_auth_disabled")}
                        type="submit">{context.translate("Продолжить")}</button>
                </div>
            </Form></div>
        )
    }
}
